import VueAutonumeric from 'vue-autonumeric'
import store from '@/store'
export const options = {
  digitGroupSeparator: ',',
  decimalCharacter: '.',
  roundingMethod: 'U',
  leadingZero: 'keep',
  emptyInputBehavior: 'null',
  modifyValueOnWheel: false,
  currencySymbol: '₺' + ' ',
  currencySymbolPlacement: 'p',
}

export default Object.assign({}, VueAutonumeric, {
  props: Object.assign({}, VueAutonumeric.props, {
    options: {
      type: Object,
      default () {
        return options;
      }
    }
  })
})
